import {useEffect} from 'react'
import CodeMirror from '@uiw/react-codemirror'
import {json} from '@codemirror/lang-json'
import {tokyoNight} from '@uiw/codemirror-theme-tokyo-night'
import {useDarkMode} from 'usehooks-ts'

import {randomInt} from '@sdox/utils'
import {useDebugStore} from '@sdox/ui'

import type {MutableRefObject} from 'react'

export const DebugData = ({data, show = false}: {data: any; show?: boolean}) => {
  const isDebug = useDebugStore().isDebugOnMode('data')
  const isDarkMode = useDarkMode()
  if (!isDebug && !show) return null

  return (
    <CodeMirror
      value={JSON.stringify(data, null, 2)}
      extensions={[json()]}
      readOnly={true}
      theme={isDarkMode ? tokyoNight : 'light'}
    />
  )
}

const colors = [
  'border-red-300',
  'border-yellow-300',
  'border-blue-300',
  'border-purple-300',
  'border-orange-300',
  'border-green-300',
]

export const useDesignDebugger = (ref: MutableRefObject<HTMLElement>, name = '') => {
  const isDebug = useDebugStore().isDebugOnMode('design')

  useEffect(() => {
    if (!ref.current || !isDebug) return

    if (ref.current.getAttribute('debug') === 'true') return

    ref.current.setAttribute('title', name)
    ref.current.classList.add(
      'border-1',
      colors[randomInt(0, colors.length)],
      'before:content-[attr(title)]',
    )
    ref.current.setAttribute('debug', 'true')
  }, [ref, isDebug, name])
}